// Set to false to disable the OTP identity check + per-passenger visibility
// filtering on Current/All Communications for testing - everyone sees every
// etrail on the booking again, exactly as before this feature existed. The
// "allow other guests to view" checkbox on the submit form keeps working
// either way, since that's just data capture - this only toggles the
// viewing-side gate/filter.
export const COMMUNICATIONS_PRIVACY_ENABLED = false
